module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/snow-ef3313dae88a5d1dbccb8653e2206da0.svg";